/** A candidate card's line under the name: title and employer, only the parts that
 * exist („Data Engineer · Acme GmbH", „Acme GmbH"), as the PDF does; null when neither (#163). */
export function cardSubtitle(
  title: string | null | undefined,
  employer: string | null | undefined,
): string | null {
  const line = [title, employer]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" · ");
  return line || null;
}

/** The process stepper's one line on phones (#163): „Schritt 3 von 5 · Qualifizierung". */
export function stepSummary(labels: readonly string[], current: number): string {
  const label = labels[current];
  return label ? `Schritt ${current + 1} von ${labels.length} · ${label}` : "";
}
